// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9cf46cd3","239":"83f7f5c2","453":"06ad6595","455":"02258ef4"}[chunkId] + ".chunk.js";
};